<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Equipment' }" tag="li" class="breadcrumb-item">
                        <a href="#">專用裝備</a>
                    </router-link>
                </ol>
            </nav>
            <div class="item-box mb-3">
                <h3 class="item-title mb-3">
                    {{ $t("UniqueEquipmentList") }}
                    <button @click="goThere()" class="pcbtn ml-3 float-right">#New</button>
                    <button @click="filterUqSlot == 2 ? (filterUqSlot = 0) : (filterUqSlot = 2)" :class="{ active: filterUqSlot == 2 }" class="pcbtn ml-3 float-right">Uq 2</button>
                </h3>
                <template v-for="(group, index) in filterData">
                    <div class="mb-3">
                        <h3 class="item-title">No. {{ index }}</h3>
                        <div class="row" :id="'uq' + index">
                            <div class="col-12 col-md-4 mb-3" v-for="item in group">
                                <router-link :to="{ name: 'CharacterDetail', params: { id: item.kana } }">
                                    <div class="prod-info-box unique uq-page" style="overflow: hidden;">
                                        <div class="row">
                                            <div class="col-12">
                                                <h2>
                                                    <button :class="Number(item.equip_slot) == 1 ? 'class1' : 'class2'">{{ $t("UniqueEquipment") }} {{ item.equip_slot }}</button>
                                                    <br />
                                                    <span style="font-family: '微軟正黑體';font-weight: bold">
                                                        {{ getI18nName(item, "equipment_name") }}
                                                    </span>
                                                </h2>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <img v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" width="80" />
                                            </div>
                                            <div class="col-6">
                                                <img width="80" v-lazy="'/static/images/equipment/icon_equipment_' + item.equipment_id + '.png'" :alt="item.equipment_name" :title="item.equipment_name" />
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                                <!-- {{item.equipment_id}} -->
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="item-box mb-3">
                <h3 class="item-title">
                    專武女神石計算機
                </h3>
                <router-link :to="{ name: 'Megami' }">
                    簡易計算機連結
                </router-link>
            </div>
            <div class="item-box mb-3">
                <h3 class="item-title">
                    專用裝備需要道具一覽
                </h3>
                <table class="chara-table mb-3">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ $t("PrincessHeart") }}</th>
                            <th>{{ $t("MemoryPieces") }}</th>
                            <th>{{ $t("Mana") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>製作</td>
                            <td><img v-lazy="'/static/images/equipment/icon_equipment_140000.png'" width="30" />公主心×3</td>
                            <td>50</td>
                            <td>100萬</td>
                        </tr>
                        <tr>
                            <td>解放(30→50)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×5
                            </td>
                            <td>10</td>
                            <td>5萬</td>
                        </tr>
                        <tr>
                            <td>解放(50→70)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×5
                            </td>
                            <td>10</td>
                            <td>15萬</td>
                        </tr>
                        <tr>
                            <td>解放(70→90)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×8
                            </td>
                            <td>10</td>
                            <td>25萬</td>
                        </tr>
                        <tr>
                            <td>解放(90→110)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>10</td>
                            <td>40萬</td>
                        </tr>
                        <tr>
                            <td>解放(110→130)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>10</td>
                            <td>50萬</td>
                        </tr>
                        <tr>
                            <td>解放(130→140)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(140→150)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(150→160)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(160→170)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(170→180)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(180→190)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(190→200)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(200→210)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>60萬</td>
                        </tr>
                        <tr>
                            <td>解放(210→220)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>80萬</td>
                        </tr>
                        <tr>
                            <td>解放(220→230)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>15</td>
                            <td>80萬</td>
                        </tr>
                        <tr>
                            <td>解放(230→240)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>80萬</td>
                        </tr>
                        <tr>
                            <td>解放(240→250)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>解放(250→260)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>解放(260→270)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>解放(270→280)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>解放(280→290)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>解放(290→300)</td>
                            <td>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×10
                            </td>
                            <td>5</td>
                            <td>90萬</td>
                        </tr>
                        <tr>
                            <td>合計</td>
                            <td>
                                <span class="mb-1 d-block">
                                    <img v-lazy="'/static/images/equipment/icon_equipment_140000.png'" width="30" alt="" />
                                    公主心×3(碎片30)
                                </span>
                                <img v-lazy="'/static/images/equipment/icon_equipment_140001.png'" width="30" alt="碎片" />
                                碎片×208
                            </td>
                            <td>285</td>
                            <td>1495萬</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-box my-3">
                <h3 class="item-title">
                    專用裝備強化花費一覽
                </h3>
                <table class="chara-table mb-3">
                    <thead>
                        <tr>
                            <th>{{ $t("Level") }}</th>
                            <th>{{ $t("ManaCost") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1→30</td>
                            <td>24萬5000</td>
                        </tr>
                        <tr>
                            <td>30→50</td>
                            <td>45萬</td>
                        </tr>
                        <tr>
                            <td>50→70</td>
                            <td>75萬</td>
                        </tr>
                        <tr>
                            <td>70→90</td>
                            <td>135萬</td>
                        </tr>
                        <tr>
                            <td>90→110</td>
                            <td>195萬</td>
                        </tr>
                        <tr>
                            <td>110→130</td>
                            <td>255萬</td>
                        </tr>
                        <tr>
                            <td>130→140</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>140→150</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>150→160</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>160→170</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>170→180</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>180→190</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>190→200</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>200→210</td>
                            <td>150萬</td>
                        </tr>
                        <tr>
                            <td>210→220</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>220→230</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>230→240</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>240→250</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>250→260</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>260→270</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>270→280</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>280→290</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>290→300</td>
                            <td>170萬</td>
                        </tr>
                        <tr>
                            <td>合計</td>
                            <td>3,353萬5000</td>
                        </tr>
                    </tbody>
                </table>
                來源 <a href="https://gamewith.jp/pricone-re/article/show/130583" target="_blank">gamewith搬移</a>
            </div>
            <div class="item-box">
                <h3 class="item-title">
                    專用裝備2
                </h3>
                <table class="chara-table mb-3">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>花費</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="width: 25.6014%;" class="th">工程</td>
                            <td style="width: 74.2268%;" class="th">必要アイテム数</td>
                        </tr>
                        <tr>
                            <td style="width: 25.6014%; text-align: center;">作成</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }} × 50 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 1000万
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 25.6014%; text-align: center;">★1</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×10 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 500万
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 25.6014%; text-align: center;">★2</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×15 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 750万
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center; width: 25.6014%;">★3</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×20 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 1000万
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center; width: 25.6014%;">★4</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×25 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 1250万
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center; width: 25.6014%;">★5</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×30 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 1500万
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center; width: 25.6014%;">合計</td>
                            <td style="width: 74.2268%;">
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_32046.png'" />
                                {{ $t("MemoryPieces") }}×150個 <br /><br />
                                <img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_94001.png'" />
                                {{ $t("Mana") }} × 6000万
                            </td>
                        </tr>
                    </tbody>
                </table>
                來源 <a href="https://gamewith.jp/pricone-re/article/show/412488" target="_blank">gamewith搬移</a>
            </div>
        </div>
    </div>
</template>
<script>
import unit_unique_equip from "../assets/edata/unit_unique_equipment.txt";
import unique_equipment_data from "../assets/edata/unique_equipment_data.txt";
export default {
    name: "UniqueEquipment",
    data() {
        return {
            unit_unique_equip_data: {},
            filterUqSlot: 0,
            ue_open_time: {
                "1": "130011,130031,130021,130211,130281,130291,130581,130591,130601",
                "2": "130301,130321,130341,130461,130481,130631",
                "3": "130061,130091,130111,130221,130271,130311,130471,130491,130511",
                "4": "130121,130171,130261,130331,130431,130521",
                "5": "130051,130151,130181,130371,130381,130401",
                "6": "130081,130231,130251,130451,130531,130571",
                "7": "130041,130071,130201,130361,130441,130501",
                "8": "130101,130161,130421,130541",
                "9": "130751,130761,130781",
                "10": "130131,130141,130561",
                "11": "130771,130801,130791",
                "12": "130551",
                "13": "130811,130821,130831",
                "14": "130841,130851,130861",
                "15": "130871,130881,130891",
                "16": "130901,130911",
                "17": "130711",
                "18": "130921,130931,130941",
                "19": "130951,130961",
                "20": "131001,131011,131031",
                "21": "130611",
                "22": "131041,131051,131061",
                "23": "131071,131081",
                "24": "131111,131121,131131",
                "25": "130651,131141",
                "26": "130971,130981,130991",
                "27": "131151,131161,131171",
                "28": "131191,131201,131211",
                "29": "131221,131231",
                "30": "131241,131251,131261",
                "31": "131091,131101",
                "32": "131271,131281",
                "33": "130661,131291,131301",
                "34": "131311,131321,131331",
                "35": "131341,131351,131361",
                "36": "130701",
                "37": "131371,131381",
                "38": "131391,131401,131411",
                "39": "131421,131431",
                "40": "131441,131451,131461",
                "41": "131181,131471,131501",
                "42": "130641,131571,131551,131561",
                "43": "131581,131591,131601",
                "44": "138021,138041",
                "45": "131621,131631",
                "46": "131651,131661,",
                "47": "131671,131681,131691",
                "48": "131711,131701",
                "49": "131721,131731,131741",
                "50": "131751,131761,131801",
                "51": "131771,131781,131791",
                "52": "131901,131911",
                "53": "138011,138061",
                "54": "131921,131931,131991",
                "55": "132071,132081,132091",
                "56": "131641,132101,132111,132121",
                "57": "130681",
                "58": "132131,132141",
                "59": "132151,132161",
                "60": "132191,132201",
                "61": "138031",
                "62": "132211,132221,132231",
                "63": "132241,132251,132261",
                "64": "132271,132281,132291",
                "65": "130772,130792,130802",
                "66": "132311,132321,132331",
                "67": "130162,130602",
                "68": "130812,130822,130832",
                "69": "132351,132361,132371",
                "70": "132381,132391",
                "71": "130332,130582",
                "72": "138051",
                "73": "132401,132411,132421",
                "74": "130842,130852,130862",
                "75": "138071",
                "76": "132451,132461,132471",
                "77": "130902,130912",
                "78": "132481,132491,132501",
                "79": "130112,130492,132001,132511,132521",
                "80": "130952,130962",
                "81": "132531,132541,132581",
                "82": "130132,131072",
                "83": "132551,132561,132571",
                "84": "132621,132631",
                "85": "131002,131012,131032",
                "86": "132661,132671,132681",
                "87": "131042,131052,131062",
                "88": "132691,132701,132711",
            },
        };
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "專用裝備列表",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [{ charset: "utf-8" }, { name: "description", content: "超異域公主連結☆Re:Dive 的裝備列表" }],
    },
    methods: {
        setFilterType: function(type) {},
        setFilterProperty: function(type) {},
        goThere: function() {
            document.getElementById("uq83").scrollIntoView({
                behavior: "smooth",
            });
            // $('body,html').animate({
            // 	scrollTop: height // Scroll to top of body
            // }, 500);
        },
        getI18nName: function(item, name) {
            switch (this.locale) {
                case "en":
                    return item["en_" + name];
                    break;
                case "jp":
                    return item["jp_" + name];
                    break;
                default:
                    return item[name];
                    break;
            }
        },
    },
    computed: {
        filterData: function() {
            let unitData = this.unit_unique_equip_data;
            if (this.filterUqSlot != 2) {
                return unitData;
            } else {
                const cloneUnitData = _.cloneDeep(unitData);
                _.forOwn(cloneUnitData, function(value, key) {
                    if (value[0].equip_slot != 2) {
                        delete cloneUnitData[key];
                    }
                });
                return cloneUnitData;
            }
        },
        locale() {
            return this.$i18n.locale;
        },
    },
    created: function() {
        var self = this;
        var unitUniqueEquipData = JSON.parse(self.atou(unique_equipment_data));
        var unitUniqueEquip = JSON.parse(self.atou(unit_unique_equip));

        const uniqueData = unitUniqueEquipData.map((o) => {
            for (const [open_time_key, equipment_ids] of Object.entries(self.ue_open_time)) {
                if (equipment_ids.includes(o.equipment_id)) {
                    o["wave"] = Number(open_time_key);
                }
            }
            const matchingEquip = unitUniqueEquip.find((j) => o.equipment_id === j.equip_id);

            if (matchingEquip) {
                const unit_data = _.find(this.$store.getters.getUnitData, ["unit_id", matchingEquip.unit_id.toString()]);
                o.kana = unit_data.kana;
                o.equip_slot = matchingEquip.equip_slot;
                o.unit_id = matchingEquip.unit_id;
            }
            return o;
        });

        const sortedAndGroupedData = _.groupBy(_.orderBy(uniqueData, ["equipment_id"], ["asc"]), "wave");
        this.unit_unique_equip_data = sortedAndGroupedData;

        let undefineWave = "";
        uniqueData
            .filter((item) => !item.wave)
            .forEach((element) => {
                undefineWave += element.equipment_id + ",";
            });
        console.log(undefineWave);
    },
    mounted: function() {},
};
</script>
<style scoped>
.class1 {
    margin-bottom: 5px;
    padding: 1px 25px;
    display: inline-block;
    border-radius: 5px;
    font-size: 0.8125rem;
    border: 1px solid #c45b39;
    text-shadow: 0px 0px 1px #080808;
    background: linear-gradient(to bottom, #f2825b 0%, #e55b2b 50%, #f07146 100%);
    color: white;
}

.class2 {
    margin-bottom: 5px;
    padding: 1px 25px;
    display: inline-block;
    border-radius: 5px;
    font-size: 0.8125rem;
    border: 1px solid #c45b39;
    text-shadow: 0px 0px 1px #080808;
    background: linear-gradient(to bottom, #499bea 0%, #207ce5 100%);
    color: white;
}
</style>
